import { Typography } from '@mui/material';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';
// import { RouteImage } from '../../assets/routeImage';
// import { colors } from '../../constants/colors';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);


type props = {
    className?: string;
    maxWidth?: string;
    heading: string;
    labelProps: string[];
    min?: number;
    max?: number;
    datasets: any;
    topicHeader?: string;
}


const VerticalBarChart: React.FC<props> = (props: props) => {
    const data = {
        labels: props.labelProps,
        datasets: props.datasets,
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom' as const,
                align: 'start' as const,
            },
            title: {
                display: true,
                text: props.topicHeader ? props.topicHeader : '',
            },
        },
        scales: {
            y: {
                min: props.min ? props.min : 0,
                max: props.max ? props.max : 100,
            },
        },
    };
    return (
        <div className={`w-full shadow-sm rounded-xl border-[1px] rounded-t-xl border-[#E5E5E7] flex flex-col ${props.className}`}>
            <span className='w-full p-3 flex justify-between items-center border-[1px] rounded-t-xl border-[#E5E5E7]'>
                <Typography variant='h6'>
                    {props.heading}
                </Typography>
                {/* <Button sx={{ borderRadius: "10px" }} startIcon={<img src={RouteImage.dropdownDot} />}>

                </Button> */}
            </span>
            <span className='px-2 py-3'>
                <Bar options={options} data={data} />
            </span>
        </div>
    );
}

export default VerticalBarChart;

